import { useAuth } from "common/hooks/useAuth";
import { ERRORS } from "errors";
import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ProtectedForAdminsOrManager = () => {
  // States
  const [loading, setLoading] = useState(true);

  // Contexts
  const { isUserAdmin, isUserManager } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isUserAdmin || isUserManager) {
      setLoading(false);
      return;
    }
    toast.error(ERRORS.error_129);
    navigate(-1);
  }, [isUserAdmin, isUserManager, navigate]);

  return !loading && <Outlet />;
};

export default ProtectedForAdminsOrManager;
